import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = "FGM Apparel Blog — Mindset, Style + Ambassador Stories";
        const desc = document.querySelector('meta[name="description"]');
        const original = desc?.getAttribute("content");
        desc?.setAttribute(
            "content",
            "The FGM Apparel blog — long-form pieces on the Focus. Grind. Motivate. mindset, building a streetwear wardrobe that survives the gym, and how our 5%-15% ambassador program actually works."
        );
        // Inject Blog ItemList JSON-LD for crawlers
        axios.get(`${API}/blog`)
            .then((r) => {
                setPosts(r.data || []);
                document.getElementById("fgm-blog-jsonld")?.remove();
                const items = (r.data || []).map((p, i) => ({
                    "@type": "ListItem",
                    "position": i + 1,
                    "url": `https://fgmapparel.com/blog/${p.slug}`,
                    "name": p.title,
                }));
                const node = {
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "name": "FGM Apparel Blog",
                    "itemListElement": items,
                };
                const el = document.createElement("script");
                el.id = "fgm-blog-jsonld";
                el.type = "application/ld+json";
                el.text = JSON.stringify(node);
                document.head.appendChild(el);
            })
            .catch(() => { /* silent */ })
            .finally(() => setLoading(false));
        return () => {
            if (original) desc?.setAttribute("content", original);
            document.getElementById("fgm-blog-jsonld")?.remove();
        };
    }, []);

    return (
        <div className="App grain bg-fgm-dark min-h-screen" data-testid="blog-page">
            <Header />
            <main className="max-w-5xl mx-auto px-6 md:px-10 py-20">
                <div className="flex items-center gap-4 mb-4">
                    <span className="h-px w-12 bg-[#E63946]" />
                    <span className="font-display tracking-[0.35em] text-zinc-400 text-sm uppercase">
                        / The Journal
                    </span>
                </div>
                <h1 className="font-display uppercase text-white text-5xl md:text-7xl leading-[0.9] tracking-tight mb-4">
                    FGM <span className="font-outline-strong">Blog</span>
                </h1>
                <p className="text-zinc-400 max-w-2xl text-base md:text-lg leading-relaxed mb-12">
                    Mindset. Style. Sweat. Three pillars, written down.
                </p>

                {loading && (
                    <div className="text-zinc-500 font-mono text-sm" data-testid="blog-loading">Loading…</div>
                )}

                {!loading && posts.length === 0 && (
                    <div className="text-zinc-500 font-mono text-sm" data-testid="blog-empty">No posts yet.</div>
                )}

                <div className="space-y-10" data-testid="blog-list">
                    {posts.map((p) => (
                        <article
                            key={p.id}
                            data-testid={`blog-card-${p.slug}`}
                            className="border-b border-white/10 pb-10 group"
                        >
                            <div className="text-[10px] font-display tracking-[0.3em] uppercase text-zinc-500 mb-3">
                                {p.tags?.slice(0, 3).join(" · ") || "FGM Editorial"}
                            </div>
                            <Link
                                to={`/blog/${p.slug}`}
                                data-testid={`blog-link-${p.slug}`}
                                className="block"
                            >
                                <h2 className="font-display uppercase text-white text-2xl md:text-4xl leading-tight tracking-tight mb-3 group-hover:text-[#E63946] transition-colors">
                                    {p.title}
                                </h2>
                                <p className="text-zinc-400 text-sm md:text-base leading-relaxed max-w-3xl mb-4">
                                    {p.excerpt}
                                </p>
                                <span className="inline-flex items-center gap-2 text-[#E63946] font-display tracking-[0.25em] uppercase text-xs">
                                    Read full piece →
                                </span>
                            </Link>
                        </article>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
